/* sk-product-notice.js
   Product-page delivery-restriction notice, inserted in the top spot
   (above Add to Cart) and hiding the theme's generic #skda-pdp box:
     - 'Pickup Only' / 'Local Only' / 'Same Day Only' -> pickup/local notice (blue)
     - 'Ground Shipping Only'                          -> ground notice w/ flat $9.99 (amber)
   Also hides the theme's redundant restriction <p> inside the product form.
   The lower .v18-delivery group is left untouched.
   Tags are read from /products/{handle}.js. External asset (minifier-safe). */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function placeNotice(box) {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form && form.parentNode) { form.parentNode.insertBefore(box, form); return; }
    var price = document.querySelector('.pr_price_single');
    if (price) price.insertAdjacentElement('afterend', box);
  }
  /* Hide the theme's redundant restriction paragraph (now combined into the box). */
  function hideLegacyNote() {
    var scope = document.querySelector('.wrap-product-info') || document;
    var ps = scope.querySelectorAll('p');
    Array.prototype.slice.call(ps).forEach(function (p) {
      if (p.closest('.sk-pdp-notice')) return;
      var t = (p.textContent || '').toLowerCase();
      if (t.length < 500 && (
        t.indexOf('ground shipping only') !== -1 ||
        t.indexOf('shipped via ground shipping') !== -1 ||
        t.indexOf('available for local delivery') !== -1 ||
        t.indexOf('in-store pickup only') !== -1 ||
        t.indexOf('cannot be shipped') !== -1
      )) {
        p.style.display = 'none';
      }
    });
  }
  ready(function () {
    if (location.pathname.indexOf('/products/') !== 0) return;
    var handle = location.pathname.split('/products/')[1];
    if (!handle) return;
    handle = handle.split('/')[0].split('?')[0];
    if (!handle) return;

    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var tags = (p.tags || []).map(String);
        var isPickup = tags.indexOf('Pickup Only') !== -1 ||
                       tags.indexOf('Local Only') !== -1 ||
                       tags.indexOf('Same Day Only') !== -1;
        var isGround = tags.indexOf('Ground Shipping Only') !== -1;
        if (!isPickup && !isGround) return;

        hideLegacyNote();
        if (document.querySelector('.sk-pdp-notice')) return;

        var box = document.createElement('div');

        if (isPickup) {
          document.body.classList.add('sk-pickup-only');
          box.className = 'sk-pdp-notice sk-pdp-notice--pickup';
          box.innerHTML =
            '<span class="sk-pdp-notice__icon">🛒</span>' +
            '<span class="sk-pdp-notice__txt">' +
              '<strong>Free in-store pickup.</strong> ' +
              'This item is available for free pickup at your chosen ShopSK location. ' +
              'Add it to your cart and confirm your store at checkout.' +
            '</span>';
        } else {
          document.body.classList.add('sk-ground-only');
          box.className = 'sk-pdp-notice sk-pdp-notice--ground';
          box.innerHTML =
            '<span class="sk-pdp-notice__icon">📦</span>' +
            '<span class="sk-pdp-notice__txt">' +
              '<strong>Free in-store pickup.</strong> ' +
              'This item is available for free pickup at your chosen ShopSK location. ' +
              'Add it to your cart and confirm your store at checkout.' +
            '</span>';
        }

        placeNotice(box);
      })
      .catch(function () {});
  });
})();
